import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, unref as _unref, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../assets/logo-sigel.png'


const _hoisted_1 = { class: "login-page" }
const _hoisted_2 = { class: "login-container" }
const _hoisted_3 = { class: "logo-section" }
const _hoisted_4 = { class: "welcome-title" }
const _hoisted_5 = { class: "welcome-subtitle" }
const _hoisted_6 = { class: "login-form-container" }
const _hoisted_7 = { class: "form-header" }
const _hoisted_8 = { class: "form-title" }
const _hoisted_9 = { class: "form-subtitle" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "input-container" }
const _hoisted_12 = {
  for: "username",
  class: "input-label"
}
const _hoisted_13 = {
  key: 0,
  class: "error-text"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "input-container" }
const _hoisted_16 = ["type"]
const _hoisted_17 = {
  for: "password",
  class: "input-label"
}
const _hoisted_18 = {
  key: 0,
  class: "error-text"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "btn-content"
}
const _hoisted_21 = {
  key: 1,
  class: "loading-content"
}
const _hoisted_22 = {
  key: 0,
  class: "error-message"
}
const _hoisted_23 = { class: "form-footer" }
const _hoisted_24 = { class: "help-text" }
const _hoisted_25 = { class: "page-footer" }

import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/admin/authStore";
import { ElNotification } from "element-plus";
import { useI18n } from "vue-i18n";
import { useLgpdConsent } from "@/composables/useLgpdConsent";


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const { t } = useI18n();

const router = useRouter();
const authStore = useAuthStore();

const currentYear = new Date().getFullYear();
const username = ref("");
const password = ref("");
const showPassword = ref(false);

const showUsernameError = ref(false);
const showPasswordError = ref(false);
const usernameError = ref("");
const passwordError = ref("");

const togglePassword = () => {
  showPassword.value = !showPassword.value;
};

const validateForm = (): boolean => {
  let isValid = true;
  
  showUsernameError.value = false;
  showPasswordError.value = false;
  usernameError.value = "";
  passwordError.value = "";
  if (!username.value.trim()) {
    showUsernameError.value = true;
    usernameError.value = t('login.usernameRequired');
    isValid = false;
  } else if (username.value.length < 3) {
    showUsernameError.value = true;
    usernameError.value = t('login.usernameMinLength');
    isValid = false;
  }

  if (!password.value.trim()) {
    showPasswordError.value = true;
    passwordError.value = t('login.passwordRequired');
    isValid = false;
  } else if (password.value.length < 4) {
    showPasswordError.value = true;
    passwordError.value = t('login.passwordMinLength');
    isValid = false;
  }

  return isValid;
};

const handleLogin = async () => {
  if (!validateForm()) {
    return;
  }

  try {
    const credentials = {
      username: username.value.trim(),
      password: password.value,
    };

    await authStore.login(credentials);

    ElNotification({
      title: t('common.success'),
      message: t('login.loginSuccess'),
      type: 'success',
    });

    // Check LGPD consent before proceeding
    const consentGranted = await useLgpdConsent()
    if (!consentGranted) return

    if (!authStore.lojaId) {
      router.push("/setup");
    } else {
      router.push("/home");
    }

  } catch (error: any) {
    ElNotification({
      title: t('login.loginError'),
      message: authStore.error || t('login.loginError'),
      type: 'error',
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"background-animation\"><div class=\"gradient-bg\"></div><div class=\"floating-shapes\"><div class=\"shape shape-1\"></div><div class=\"shape shape-2\"></div><div class=\"shape shape-3\"></div><div class=\"shape shape-4\"></div></div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "logo-container" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "SisGel Logo",
            class: "logo"
          })
        ], -1)),
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('login.welcome')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('login.subtitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h2", _hoisted_8, [
            _cache[3] || (_cache[3] = _createElementVNode("i", { class: "fas fa-user-circle" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('login.formTitle')), 1)
          ]),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t('login.formSubtitle')), 1)
        ]),
        _createElementVNode("form", {
          onSubmit: _withModifiers(handleLogin, ["prevent"]),
          class: "login-form"
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-user input-icon" }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((username).value = $event)),
                id: "username",
                placeholder: "",
                required: "",
                class: _normalizeClass(["form-input", { 'has-error': showUsernameError.value }])
              }, null, 2), [
                [_vModelText, username.value]
              ]),
              _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('login.username')), 1)
            ]),
            (showUsernameError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                  _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(usernameError.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-lock input-icon" }, null, -1)),
              _withDirectives(_createElementVNode("input", {
                type: showPassword.value ? 'text' : 'password',
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                id: "password",
                placeholder: "",
                required: "",
                class: _normalizeClass(["form-input", { 'has-error': showPasswordError.value }])
              }, null, 10, _hoisted_16), [
                [_vModelDynamic, password.value]
              ]),
              _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('login.password')), 1),
              _createElementVNode("button", {
                type: "button",
                onClick: togglePassword,
                class: _normalizeClass(["password-toggle", { 'active': showPassword.value }])
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(showPassword.value ? 'fas fa-eye-slash' : 'fas fa-eye')
                }, null, 2)
              ], 2)
            ]),
            (showPasswordError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fas fa-exclamation-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(passwordError.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", {
            type: "submit",
            class: _normalizeClass(["login-btn", { 'loading': _unref(authStore).isLoading }]),
            disabled: _unref(authStore).isLoading
          }, [
            (!_unref(authStore).isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fas fa-sign-in-alt" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('login.enter')), 1)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                  _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fas fa-spinner fa-spin" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('login.entering')), 1)
                ]))
          ], 10, _hoisted_19),
          (_unref(authStore).error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_unref(authStore).error), 1)
              ]))
            : _createCommentVNode("", true)
        ], 32),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("p", _hoisted_24, [
            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-info-circle" }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('login.help')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("p", null, "© " + _toDisplayString(_unref(currentYear)) + " " + _toDisplayString(_ctx.$t('login.footer')), 1)
    ])
  ]))
}
}

})